import { render, staticRenderFns } from "./tx-multisig-create-order.svg?vue&type=template&id=5f2d63b6&vue"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports